import { render, staticRenderFns } from "./ParticipantDetailsCard.vue?vue&type=template&id=50f16b3c&scoped=true"
import script from "./ParticipantDetailsCard.vue?vue&type=script&lang=js"
export * from "./ParticipantDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./ParticipantDetailsCard.vue?vue&type=style&index=0&id=50f16b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f16b3c",
  null
  
)

export default component.exports